import React, { useState } from 'react';
import { Container, Typography, Button, Paper, Collapse } from '@mui/material';

export default function Careers() {
  React.useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
  }, []);

  // State to track expanded job panels (keyed by job ID)
  const [expandedJob, setExpandedJob] = useState(null);

  // Job listings
  const jobs = [
    {
      id: 'job1',
      title: 'Software Engineer (Remote - US)',
      location: 'Remote',
      type: 'Full-Time',
      experience: '3+ Years',
      responsibilities: [
        'Develop and maintain ERP & CRM integrations for Salesforce & NetSuite.',
        'Work with React, Node.js, and cloud platforms to build scalable applications.',
        'Collaborate with cross-functional teams to enhance business workflows.',
        'Ensure high-quality code with best development practices.',
      ],
    },
    {
      id: 'job2',
      title: 'Software Engineer (Remote - US)',
      location: 'Remote',
      type: 'Full-Time',
      experience: '5+ Years',
      responsibilities: [
        'Design and implement scalable cloud solutions using AWS and Azure.',
        'Optimize cloud architecture for security, performance, and cost-efficiency.',
        'Work with engineering teams to integrate cloud infrastructure with applications.',
        'Lead the migration of legacy systems to modern cloud environments.',
      ],
    },
  ];

  // Toggle expand/collapse for specific job
  const toggleExpand = (jobId) => {
    setExpandedJob(expandedJob === jobId ? null : jobId); // Collapse if already open
  };

  const handleApplyNow = (jobTitle) => {
    window.location.href = `mailto:careers@falconxcellence.com?subject=Application - ${jobTitle}&body=Dear Hiring Team,`;
  };

  return (
    <Container maxWidth="md" sx={{ py: { xs: 8, sm: 16 } }}>
      <Typography variant="h4" gutterBottom align="left">
        Join Our Team
      </Typography>
      <Typography variant="body1" align="left" sx={{ mb: 4 }}>
        We are looking for talented individuals to grow with us. Click a job to see details.
      </Typography>

      {/* Loop through job listings */}
      {jobs.map((job) => (
        <Paper
          key={job.id}
          sx={{ p: 3, mb: 2, cursor: 'pointer', transition: '0.3s', '&:hover': { boxShadow: 6 } }}
          onClick={() => toggleExpand(job.id)}
        >
          <Typography variant="h5" gutterBottom>
            {job.title}
          </Typography>
          <Typography variant="body2" color="text.secondary">
            📍 <b>Location:</b> {job.location} | 💼 <b>Type:</b> {job.type} | 📅 <b>Experience:</b>{' '}
            {job.experience}
          </Typography>

          {/* Expandable Section for Job Details */}
          <Collapse in={expandedJob === job.id} timeout="auto" unmountOnExit>
            <Typography variant="h6" sx={{ mt: 2 }}>
              Roles & Responsibilities:
            </Typography>
            {job.responsibilities.map((responsibility, index) => (
              <Typography key={index} variant="body2" sx={{ mt: 1 }}>
                - {responsibility}
              </Typography>
            ))}

            {/* Apply Now Button */}
            <Button
              variant="contained"
              color="primary"
              sx={{ mt: 2 }}
              onClick={(e) => {
                e.stopPropagation(); // Prevents collapsing when clicking the button
                handleApplyNow(job.title);
              }}
            >
              Apply Now
            </Button>
          </Collapse>
        </Paper>
      ))}
    </Container>
  );
}
